import React, { Component } from 'react';
import Header from '../../Layout/Header'
import { Link } from 'react-router-dom'
// import Sidebar from '../Blog/Sidebar'

class WhatWeDo extends Component {
	render() {
		return (
			<div>
				<Header
					seoTitle="What We Do"
					title={"what we do"}
					image={require('./image.jpg')}
				/>
				<div className="entry-content page-blog">
					
					<div className="container-fluid">
						<h2 className="outline text-center">
							<div className="line"></div>
							<div className="title">
								<img src={require("./moshi-icon.png")} alt="Icon" width="48"
									style={{
									marginTop: -18,
										marginBottom: -12,
									marginRight:12, 
								}} />
								Marketing, Direct and Digital
							</div>
						</h2>
					</div>

					<div className="container">
						<div className="row">
							<div className="col-lg-7">
								<QuickSelectBoxMarketing />
							</div>
							<div className="col-lg-5">
								<div className="tagline">Our job is to connect your customers to you. Our first task is to understand your customers.</div>
								<p>All Moshi’s marketing services start with getting to the core of <b>why</b> your customers need you.  Then we can develop the right messaging to get their attention.</p>
								<p>We look at your customers' <b>behaviour</b> to find the best ways to build brand awareness and be there when they need you. </p>
								<p>Backed up by detailed <b>data</b> analysis, Moshi provides a measurable marketing strategy that speaks directly to your customers.</p>
							</div>
						</div>
					</div>

					<div className="container-fluid">
						<h2 className="outline text-center">
							<div className="line"></div>
							<div className="title">
								<img src={require("./moshi-icon.png")} alt="Icon" width="48"
									style={{
									marginTop: -18,
										marginBottom: -12,
									marginRight:12, 
								}} />
								Graphic Design, Creativity and Content
							</div>
						</h2>
					</div>

					<div className="container">
						<div className="row">
							<div className="col-lg-7">
								<QuickSelectBoxGraphics />
							</div>
							<div className="col-lg-5">
								<div className="tagline">Marketing strategy has to be backed up by amazing design and clear content. </div>
								<p><b>Form follows function.</b> Moshi aims to create work which is not only clear and easy to understand but achieves its business purpose.</p>
								<p>Our team has decades of <b>experience</b> designing everything from logos to TV commercials. Trust us to give your marketing material the look and feel it needs to succeed.</p>
							</div>
						</div>
					</div>

					<div className="container-fluid">
						<h2 className="outline text-center">
							<div className="line"></div>
							<div className="title">
								<img src={require("./moshi-icon.png")} alt="Icon" width="48"
									style={{
									marginTop: -18,
										marginBottom: -12,
									marginRight:12, 
								}} />
								Website, Mobile App and Software Development
							</div>
						</h2>
					</div>

					<div className="container">
						<div className="row">
							<div className="col-lg-7">
								<QuickSelectBoxWeb />
							</div>
							<div className="col-lg-5">
								<div className="tagline">Moshi creates great-looking digital tools that work.</div>
								<p>Our development team and designers work together closely to create websites, apps and custome business software that not only look <b>sharp</b> but produce <b>results</b>.</p>
								<p>All of our digital products provide rich data for ongoing <b>analysis</b>. Performance can then be <b>optimised</b> to maximise success.  </p>
							</div>
						</div>
					</div>
					
					
{/* <div className="container">
						
						<div className="row">
							<div className="col-lg-12">
							
								<h4>Marketing is a lot like fishing.</h4>

								<p>Oceans, lakes and rivers have a variety of fish and other marine life, and the best techniques to catch each of them differs. Maybe you are a trophy fisherman, trawling the deep in your boat for marlin or sail fish. Perhaps you are the beach fisherman, with a long rod and plenty of berley, or a throw net to catch bait fish. You could be targeting crayfish, so you don SCUBA gear and carry a snare. With a whole range of services at our disposal, Moshi Moshi Marketing ensures you use the right fishing techniques to catch the kind of customer you are looking for.</p>

<h1> App Development</h1>
<p>Most of the time, businesses have to wait for their customers to come to them - do you want to turn the tables? Apps are a great way to both connect with and prompt action from your customers. Our team at Moshi Moshi will work with you to create a solid business idea for your app, with your goal and end user in mind.</p>
 <Link to="/whatwedo/app-development">Read More...</Link> 
<hr/>
<h1> Brand and Logo Design</h1>
<p>A brand is more than just how your company looks. Your brand (and branding) is a unique combination of your purpose, your skills, your target market, and your voice. </p>
 <Link to="/whatwedo/brand-and-logo-design">Read More...</Link> 
<hr/>
<h1> Custom Programmed Systems</h1>
<p>Could your business systems be more efficient? How valuable is extra time to your company? A custom programmed system is essentially a way to create streamlined, efficient administration systems to save you time and money.</p>
 <Link to="/whatwedo/custom-programmed-systems">Read More...</Link> 
<hr/>
<h1> Domain Address Registration</h1>
<p>Registering a domain name (address) can be incredibly overwhelming for a new business owner. We specialise in making the domain registration process easier for you.</p>
 <Link to="/whatwedo/domain-address-registration">Read More...</Link> 
<hr/>
<h1> Ecommerce and Online Shops</h1>
<p>More and more people are turning to online shopping over the traditional retail experience. If your business sells physical goods, digital downloads or fixed price services, chances are you will benefit from an ecommerce site.</p>
 <Link to="/whatwedo/ecommerce-and-online-shops">Read More...</Link> 
<hr/>
<h1> Email Newsletter Marketing</h1>
<p>A lot of businesses think email marketing is old news - this couldn’t be further from the truth! 
Email marketing gives you the chance to stay in the forefront of your customers mind, creates a solid marketing and remarketing list, and generates communication between your brand and your stakeholders.</p>
 <Link to="/whatwedo/email-newsletter-marketing">Read More...</Link> 
<hr/>
<h1> Google Advertising</h1>
<p>Simply put, Google Ads (formerly AdWords) puts your ads above search results on Google. This means that if anyone is actively searching for products similar to yours, or with the same search terms as your ad content, your ads will appear.</p>
 <Link to="/whatwedo/google-ads">Read More...</Link> 
<hr/>
<h1> Graphic Design</h1>
<p>Our in-house Graphic Designers have a combined 30 years' experience in the field, and prepare professional print-ready or digital files of the highest quality.</p>
 <Link to="/whatwedo/graphic-design">Read More...</Link> 
<hr/>
<h1> Photography and Video Shoots</h1>
<p>Quality photography and video footage is usually the make or break decider in capturing a viewer’s attention. Your following has a huge chance to grow with high quality, creative content.</p>
 <Link to="/whatwedo/photography-and-video-shoots">Read More...</Link> 
<hr/>
<h1> Public Relations</h1>
<p>Public Relations refers to how your company is seen to the public. Whether you’re a small or large business in the South West, keeping your public profile updated is crucial.</p>
 <Link to="/whatwedo/public-relations">Read More...</Link> 
<hr/>
<h1> Social Media Management</h1>
<p>Your social platforms are generally the first thing your audience will go to for their preliminary research into your brand. Our aim is to create a clear direction and intent for your social posts, and create engaging, authentic content for your audience.</p>
 <Link to="/whatwedo/social-media-management">Read More...</Link> 
<hr/>
<h1> Social Media Marketing</h1>
<p>Social Media Marketing is a fantastic way to get your ads in front of your customers. Depending on your business and campaign goals, there are a range of options you can choose from.</p>
 <Link to="/whatwedo/social-media-marketing">Read More...</Link> 
<hr/>
<h1>Video Production and Advertising</h1>
<p>Moshi can help you create professionally shot and edited short videos to promote your business or educate your market, at a price you can afford.</p>
 <Link to="/whatwedo/video-production-and-advertising">Read More...</Link> 
<hr/>
<h1>Website and Newsletter Content Writing</h1>
<p>Writing for the web is a completely different science to writing a novel or a magazine article. A well written website could be the difference between a conversion and a drop off.</p>
 <Link to="/whatwedo/website-and-newsletter-content-writing">Read More...</Link> 
<hr/>
<h1>Website Development</h1>
<p>In this digital age, your website is your storefront and the digital face of your brand. Whether you’re offering ecommerce, multiple services, or you’d rather  just have an easy-to-digest one page site, everything your audience needs to know should be readily available.</p>
 <Link to="/whatwedo/website-development">Read More...</Link> 
<hr/>
<h1>Website Hosting</h1>
<p>Website hosting refers to where your website is being stored on the world wide web. After investing in a great Moshi Moshi website, you no doubt want to keep it as safe and secure as possible.</p>
 <Link to="/whatwedo/website-hosting">Read More...</Link> 
<hr/>
							
							</div>
							
						</div> 
<p> If you don’t have a website yet, or your existing site isn’t converting your online traffic, come in for a zero obligation chat.</p>
					</div>*/}
				</div>

			</div>
		);
	}
}

class QuickSelectBoxMarketing extends Component {
	state = {
		active: 1
	}
	render() {
		return (
			<div className="quick-select-box">
				<div className={`quick-select ${this.state.active === 1 && "active"} `}>
					<div className="open-close-holder">
						<div className="contract" onClick={()=>this.setState({active: 0})}>
							<i className="fa fa-minus"></i>
						</div>
						<div className="expand"  onClick={()=>this.setState({active: 1})}>
							<i className="fa fa-plus"></i>
						</div>
					</div>
					<div className="row">
						<div className="col-lg-7">
							<div className="title">Search Engine Optimisation (SEO)</div>
							<div className="holder">
								<div className="desc">Having a stylish website is no use if it doesn’t show up on internet searches.  Moshi provides specialist SEO services to make sure that search engines list your website and search strength improves over time to push your listing towards the top.</div>
								<Link to="/whatwedo/search-engine-optimisation-seo" className="btn">Find Out More</Link> 
							</div>
						</div>
						<div className="col-lg-5">
							<div className="holder">
								<img src={require('./google-ads-and-seo.svg')} width="100%" alt="Google" />
							</div>
						</div>
					</div>
				</div>
				<div className={`quick-select ${this.state.active === 2 && "active"} `}>
					<div className="open-close-holder">
						<div className="contract" onClick={()=>this.setState({active: 0})}>
							<i className="fa fa-minus"></i>
						</div>
						<div className="expand"  onClick={()=>this.setState({active: 2})}>
							<i className="fa fa-plus"></i>
						</div>
					</div>
					<div className="row">
						<div className="col-lg-7">
							<div className="title">Google Ads</div>
							<div className="holder">
								<div className="desc">Simply put, Google Ads (formerly AdWords) puts your ads above search results on Google. This means that if anyone is actively searching for products similar to yours, or with the same search terms as your ad content, your ads will appear.</div>
								<Link to="/whatwedo/google-ads" className="btn">Find Out More</Link>
							</div>
						</div>
						<div className="col-lg-5">
							<div className="holder">
								<img src={require('./google-ads-and-seo.svg')} width="100%" alt="Google" />
							</div>
						</div>
					</div>
				</div>
				<div className={`quick-select ${this.state.active === 3 && "active"} `}>
					<div className="open-close-holder">
						<div className="contract" onClick={()=>this.setState({active: 0})}>
							<i className="fa fa-minus"></i>
						</div>
						<div className="expand"  onClick={()=>this.setState({active: 3})}>
							<i className="fa fa-plus"></i>
						</div>
					</div>
					<div className="row">
						<div className="col-lg-7">
							<div className="title">Social Media Marketing</div>
							<div className="holder">
								<div className="desc">Social Media Marketing is a fantastic way to get your ads in front of your customers. Depending on your business and campaign goals, there are a range of options you can choose from.</div>
								<Link to="/whatwedo/social-media-marketing" className="btn">Find Out More</Link>
							</div>
						</div>
						<div className="col-lg-5">
							<div className="holder">
								<img src={require('./social-media-marketing.svg')} width="100%" alt="Google" />
							</div>
						</div>
					</div>
				</div>
				<div className={`quick-select ${this.state.active === 4 && "active"} `}>
					<div className="open-close-holder">
						<div className="contract" onClick={()=>this.setState({active: 0})}>
							<i className="fa fa-minus"></i>
						</div>
						<div className="expand"  onClick={()=>this.setState({active: 4})}>
							<i className="fa fa-plus"></i>
						</div>
					</div>
					<div className="row">
						<div className="col-lg-7">
							<div className="title">Email Marketing</div>
							<div className="holder">
								<div className="desc">A lot of businesses think email marketing is old news - this couldn’t be further from the truth! 
Email marketing gives you the chance to stay in the forefront of your customers mind, creates a solid marketing and remarketing list, and generates communication between your brand and your stakeholders. </div>
								<Link to="/whatwedo/email-newsletter-marketing" className="btn">Find Out More</Link>
							</div>
						</div>
						<div className="col-lg-5">
							<div className="holder">
								<img src={require('./email-marketing.svg')} width="100%" alt="Google" />
							</div>
						</div>
					</div>
				</div>
				<div className={`quick-select last ${this.state.active === 5 && "active"} `}>
					<div className="open-close-holder">
						<div className="contract" onClick={()=>this.setState({active: 0})}>
							<i className="fa fa-minus"></i>
						</div>
						<div className="expand"  onClick={()=>this.setState({active: 5})}>
							<i className="fa fa-plus"></i>
						</div>
					</div>
					<div className="row">
						<div className="col-lg-7">
							<div className="title">Public Relations</div>
							<div className="holder">
								<div className="desc">Public Relations refers to how your company is seen to the public. Whether you’re a small or large business, keeping your public profile updated is crucial.</div>
								<Link to="/whatwedo/public-relations" className="btn">Find Out More</Link>
							</div>
						</div>
						<div className="col-lg-5">
							<div className="holder">
								<img src={require('./public-relations.svg')} width="100%" alt="Google" />
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

class QuickSelectBoxGraphics extends Component {
	state = {
		active: 1
	}
	render() {
		return (
			<div className="quick-select-box">
				<div className={`quick-select ${this.state.active === 1 && "active"} `}>
					<div className="open-close-holder">
						<div className="contract" onClick={()=>this.setState({active: 0})}>
							<i className="fa fa-minus"></i>
						</div>
						<div className="expand"  onClick={()=>this.setState({active: 1})}>
							<i className="fa fa-plus"></i>
						</div>
					</div>
					<div className="row">
						<div className="col-lg-7">
							<div className="title">Graphic Design</div>
							<div className="holder">
								<div className="desc">Our in-house Graphic Designers have a combined 30 years' experience in the field, and prepare professional print-ready or digital files of the highest quality.</div>
								<Link to="/whatwedo/graphic-design" className="btn">Find Out More</Link>
							</div>
						</div>
						<div className="col-lg-5">
							<div className="holder">
								<img src={require('./graphic-design.svg')} width="100%" alt="Google" />
							</div>
						</div>
					</div>
				</div>
				<div className={`quick-select ${this.state.active === 2 && "active"} `}>
					<div className="open-close-holder">
						<div className="contract" onClick={()=>this.setState({active: 0})}>
							<i className="fa fa-minus"></i>
						</div>
						<div className="expand"  onClick={()=>this.setState({active: 2})}>
							<i className="fa fa-plus"></i>
						</div>
					</div>
					<div className="row">
						<div className="col-lg-7">
							<div className="title">Brand and Logo Design</div>
							<div className="holder">
								<div className="desc">A brand is more than just how your company looks. Your brand (and branding) is a unique combination of your purpose, your skills, your target market, and your voice. </div>
								<Link to="/whatwedo/brand-and-logo-design" className="btn">Find Out More</Link>
							</div>
						</div>
						<div className="col-lg-5">
							<div className="holder">
								<img src={require('./logo-design.svg')} width="100%" alt="Google" />
							</div>
						</div>
					</div>
				</div>
				<div className={`quick-select ${this.state.active === 3 && "active"} `}>
					<div className="open-close-holder">
						<div className="contract" onClick={()=>this.setState({active: 0})}>
							<i className="fa fa-minus"></i>
						</div>
						<div className="expand"  onClick={()=>this.setState({active: 3})}>
							<i className="fa fa-plus"></i>
						</div>
					</div>
					<div className="row">
						<div className="col-lg-7">
							<div className="title">Photography and Video</div>
							<div className="holder">
								<div className="desc">Quality photography and video footage is usually the make or break decider in capturing a viewer’s attention. Your following has a huge chance to grow with high quality, creative content. </div>
								<Link to="/whatwedo/photography-and-video-shoots" className="btn">Find Out More</Link>
							</div>
						</div>
						<div className="col-lg-5">
							<div className="holder">
								<img src={require('./photography-and-video-shoots.svg')} width="100%" alt="Google" />
							</div>
						</div>
					</div>
				</div>
				<div className={`quick-select ${this.state.active === 4 && "active"} `}>
					<div className="open-close-holder">
						<div className="contract" onClick={()=>this.setState({active: 0})}>
							<i className="fa fa-minus"></i>
						</div>
						<div className="expand"  onClick={()=>this.setState({active: 4})}>
							<i className="fa fa-plus"></i>
						</div>
					</div>
					<div className="row">
						<div className="col-lg-7">
							<div className="title">Video Production</div>
							<div className="holder">
								<div className="desc">Moshi can help you create professionally shot and edited short videos to promote your business or educate your market, at a price you can afford.</div>
								<Link to="/whatwedo/video-production-and-advertising" className="btn">Find Out More</Link>
							</div>
						</div>
						<div className="col-lg-5">
							<div className="holder">
								<img src={require('./video-production.svg')} width="100%" alt="Google" />
							</div>
						</div>
					</div>
				</div>
				<div className={`quick-select ${this.state.active === 5 && "active"} `}>
					<div className="open-close-holder">
						<div className="contract" onClick={()=>this.setState({active: 0})}>
							<i className="fa fa-minus"></i>
						</div>
						<div className="expand"  onClick={()=>this.setState({active: 5})}>
							<i className="fa fa-plus"></i>
						</div>
					</div>
					<div className="row">
						<div className="col-lg-7">
							<div className="title">Social Media Management</div>
							<div className="holder">
								<div className="desc">Your social platforms are generally the first thing your audience will go to for their preliminary research into your brand. Our aim is to create a clear direction and intent for your social posts, and create engaging, authentic content for your audience.</div>
								<Link to="/whatwedo/social-media-management" className="btn">Find Out More</Link>
							</div>
						</div>
						<div className="col-lg-5">
							<div className="holder">
								<img src={require('./social-media-management.svg')} width="100%" alt="Google" />
							</div>
						</div>
					</div>
				</div>

				<div className={`quick-select last ${this.state.active === 6 && "active"} `}>
					<div className="open-close-holder">
						<div className="contract" onClick={()=>this.setState({active: 0})}>
							<i className="fa fa-minus"></i>
						</div>
						<div className="expand"  onClick={()=>this.setState({active: 6})}>
							<i className="fa fa-plus"></i>
						</div>
					</div>
					<div className="row">
						<div className="col-lg-7">
							<div className="title">Content Writing / Copywriting</div>
							<div className="holder">
								<div className="desc">Writing for the web is a completely different science to writing a novel or a magazine article. A well written website could be the difference between a conversion and a drop off.</div>
								<Link to="/whatwedo/website-and-newsletter-content-writing" className="btn">Find Out More</Link>
							</div>
						</div>
						<div className="col-lg-5">
							<div className="holder">
								<img src={require('./content-writing.svg')} width="100%" alt="Google" />
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

class QuickSelectBoxWeb extends Component {
	state = {
		active: 1
	}
	render() {
		return (
			<div className="quick-select-box">
				<div className={`quick-select ${this.state.active === 1 && "active"} `}>
					<div className="open-close-holder">
						<div className="contract" onClick={()=>this.setState({active: 0})}>
							<i className="fa fa-minus"></i>
						</div>
						<div className="expand"  onClick={()=>this.setState({active: 1})}>
							<i className="fa fa-plus"></i>
						</div>
					</div>
					<div className="row">
						<div className="col-lg-7">
							<div className="title">Website Development</div>
							<div className="holder">
								<div className="desc">In this digital age, your website is your storefront and the digital face of your brand. Whether you’re offering ecommerce, multiple services, or you’d rather  just have an easy-to-digest one page site, everything your audience needs to know should be readily available.</div>
								<Link to="/whatwedo/website-development" className="btn">Find Out More</Link>
							</div>
						</div>
						<div className="col-lg-5">
							<div className="holder">
								<img src={require('./web-development.svg')} width="100%" alt="Google" />
							</div>
						</div>
					</div>
				</div>
				<div className={`quick-select ${this.state.active === 2 && "active"} `}>
					<div className="open-close-holder">
						<div className="contract" onClick={()=>this.setState({active: 0})}>
							<i className="fa fa-minus"></i>
						</div>
						<div className="expand"  onClick={()=>this.setState({active: 2})}>
							<i className="fa fa-plus"></i>
						</div>
					</div>
					<div className="row">
						<div className="col-lg-7">
							<div className="title">App Development</div>
							<div className="holder">
								<div className="desc">Most of the time, businesses have to wait for their customers to come to them - do you want to turn the tables? Apps are a great way to both connect with and prompt action from your customers. Our team at Moshi Moshi will work with you to create a solid business idea for your app, with your goal and end user in mind.</div>
								<Link to="/whatwedo/app-development" className="btn">Find Out More</Link>
							</div>
						</div>
						<div className="col-lg-5">
							<div className="holder">
								<img src={require('./app-development.svg')} width="100%" alt="Google" />
							</div>
						</div>
					</div>
				</div>
				<div className={`quick-select ${this.state.active === 3 && "active"} `}>
					<div className="open-close-holder">
						<div className="contract" onClick={()=>this.setState({active: 0})}>
							<i className="fa fa-minus"></i>
						</div>
						<div className="expand"  onClick={()=>this.setState({active: 3})}>
							<i className="fa fa-plus"></i>
						</div>
					</div>
					<div className="row">
						<div className="col-lg-7">
							<div className="title">Ecommerce / Online Shops</div>
							<div className="holder">
								<div className="desc">More and more people are turning to online shopping over the traditional retail experience. If your business sells physical goods, digital downloads or fixed price services, chances are you will benefit from an ecommerce site.</div>
								<Link to="/whatwedo/ecommerce-and-online-shops" className="btn">Find Out More</Link>
							</div>
						</div>
						<div className="col-lg-5">
							<div className="holder">
								<img src={require('./ecommerce.svg')} width="100%" alt="Google" />
							</div>
						</div>
					</div>
				</div>
				<div className={`quick-select ${this.state.active === 4 && "active"} `}>
					<div className="open-close-holder">
						<div className="contract" onClick={()=>this.setState({active: 0})}>
							<i className="fa fa-minus"></i>
						</div>
						<div className="expand"  onClick={()=>this.setState({active: 4})}>
							<i className="fa fa-plus"></i>
						</div>
					</div>
					<div className="row">
						<div className="col-lg-7">
							<div className="title">Custom Software Systems</div>
							<div className="holder">
								<div className="desc">Could your business systems be more efficient? How valuable is extra time to your company? A custom programmed system is essentially a way to create streamlined, efficient administration systems to save you time and money.</div>
								<Link to="/whatwedo/custom-programmed-systems" className="btn">Find Out More</Link>
							</div>
						</div>
						<div className="col-lg-5">
							<div className="holder">
								<img src={require('./custom-software-systems.svg')} width="100%" alt="Google" />
							</div>
						</div>
					</div>
				</div>
				<div className={`quick-select ${this.state.active === 5 && "active"} `}>
					<div className="open-close-holder">
						<div className="contract" onClick={()=>this.setState({active: 0})}>
							<i className="fa fa-minus"></i>
						</div>
						<div className="expand"  onClick={()=>this.setState({active: 5})}>
							<i className="fa fa-plus"></i>
						</div>
					</div>
					<div className="row">
						<div className="col-lg-7">
							<div className="title">Domain Address Registration</div>
							<div className="holder">
								<div className="desc">Registering a domain name (address) can be incredibly overwhelming for a new business owner. We specialise in making the domain registration process easier for you.</div>
								<Link to="/whatwedo/domain-address-registration" className="btn">Find Out More</Link>
							</div>
						</div>
						<div className="col-lg-5">
							<div className="holder">
								<img src={require('./domain-address-registration.svg')} width="100%" alt="Google" />
							</div>
						</div>
					</div>
				</div>
				<div className={`quick-select last ${this.state.active === 6 && "active"} `}>
					<div className="open-close-holder">
						<div className="contract" onClick={()=>this.setState({active: 0})}>
							<i className="fa fa-minus"></i>
						</div>
						<div className="expand"  onClick={()=>this.setState({active: 6})}>
							<i className="fa fa-plus"></i>
						</div>
					</div>
					<div className="row">
						<div className="col-lg-7">
							<div className="title">Website Hosting</div>
							<div className="holder">
								<div className="desc">Website hosting refers to where your website is being stored on the world wide web. After investing in a great Moshi Moshi website, you no doubt want to keep it as safe and secure as possible.</div>
								<Link to="/whatwedo/website-hosting" className="btn">Find Out More</Link>
							</div>
						</div>
						<div className="col-lg-5">
							<div className="holder">
								<img src={require('./web-hosting.svg')} width="100%" alt="Google" />
							</div>
						</div>
					</div>
				</div>
			</div>
		)
	}
}


						
export default WhatWeDo;


// WEBPACK FOOTER //
// ./src/Pages/WhatWeDo/WhatWeDo.js